(ns minorodata.transformations.events
  (:require [re-posh.core :as re-posh]
            ["date-fns" :as date-fns]
            [minorodata.app.handlers :refer [reg-event-fx]]
            [minorodata.transformations.model :refer [->job]]
            [minorodata.app.utils :as utils]))


(def default-from
  (date-fns/parseISO "1900-01-01"))


(def default-to
  (date-fns/add (js/Date.now) #js {:years 10}))


(defn set-from-time [date]
  (when (some? date)
    (date-fns/set date #js {:hours 0 :minutes 0 :seconds 0})))


(defn set-to-time [date]
  (when (some? date)
    (date-fns/set date #js {:hours 23 :minutes 59 :seconds 59})))


(reg-event-fx
  :transformations.events/do-search
  (fn [_ _]
    (let [search  @(re-posh/subscribe [:transformations-search/pull])
          {:transformations-search/keys [term type updated-by updated-at status tags search-filter scheduled pagination]} search
          updated {:from (or (set-from-time (:from updated-at)) default-from)
                   :to   (or (set-to-time (:to updated-at)) default-to)}
          params  (-> {:filters {:updated-at  updated
                                 :updated-by  updated-by
                                 :scheduled   scheduled
                                 :tags        tags
                                 :status      status
                                 :type        (or type :transform)}}
                      utils/clean-up-query-recursive
                      (assoc :query       (or term "")
                             :specificity (or search-filter "titles")
                             :pagination  (or pagination
                                              utils/default-pagination)))]
      {:dispatch [:transformations.api/load-search-results params]})))


(reg-event-fx
  :transformations.events/navigate-to-search-result
  (fn [_ [{:keys [type id group-id]}]]
    (if (= type :group)
      {:dispatch-n [[:groups-panel/update {:groups-panel/groups {:group/id id}}]
                    [:app.events/navigate :transforms {:group-id id}]]}

      {:dispatch-n [[:groups-panel/update {:groups-panel/groups {:group/id group-id}}]
                    [:transforms-panel/update {:transforms-panel/transforms {:transform/id id}}]
                    [:app.events/navigate :transform-details {:group-id     group-id
                                                              :transform-id id}]
                    [:sql-console-modal.events/open-transform id]]})))


(reg-event-fx
  :transformations.events/add-initial-job
  (fn [_ [results transform-id]]
    (let [single?   (some? transform-id)
          transform (when single?
                      @(re-posh/subscribe [:transform/pull [:transform/id transform-id]]))
          job-name  (if single?
                      (:transform/name transform)
                      "All transforms")
          job-model (-> {:id           (:job/id results)
                         :name         job-name
                         :execution-id (:job-execution/id results)}
                        (utils/assoc-some
                          :task-statuses (when single?
                                           [{:transform transform-id
                                             :status    :connecting}]))
                        ->job)]
      {:dispatch [:transformations-view/update {:transformations-view/jobs job-model}]})))


(def distinct-concat
  (comp distinct concat))


(defn collect-transforms-by-status [tasks]
  (reduce
    (fn [status-map task]
      (let [{:transform/keys [starting running skipped failed completed]} task]
        (-> status-map
            (update :starting distinct-concat starting)
            (update :running distinct-concat running)
            (update :skipped distinct-concat skipped)
            (update :failed distinct-concat failed)
            (update :completed distinct-concat completed))))
    {}
    tasks))


(defn finished-notification [status tasks]
  (let [failed? (= "failed" status)
        type    (if failed? :error :success)
        {:keys [skipped failed completed]} tasks
        text    (str "Job finished. Completed: " (count completed)
                     ",  skipped: " (count skipped)
                     ", failed: " (count failed)
                     ".")]
    [:app.events/add-snack type text]))


(defn format-task-statuses [tasks]
  (->
    (for [[status transforms] tasks
          transform transforms]
      {:transform transform
       :status    status})
    vec))


(reg-event-fx
  :transformations.events/set-job-statuses
  (fn [_ [results]]
    (let [job-id        (:job/id results)
          job-status    (:job/status results)
          finished?     (or (= job-status "failed")
                            (= job-status "success"))
          tasks         (collect-transforms-by-status (:job/task-executions results))
          task-statuses (format-task-statuses tasks)
          job-model     (-> {:id         job-id
                             :status     job-status
                             :errors     (:job/errors results)
                             :start-time (:job/start-time results)
                             :end-time   (:job/end-time results)}
                            (utils/assoc-some
                              :task-statuses (when-not (empty? task-statuses)
                                               task-statuses))
                            ->job)]
      {:dispatch-n (utils/conj-when
                     [[:job/update [:job/id job-id] job-model {:replace true}]]
                     finished? (finished-notification job-status tasks))})))
